function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDc2TogR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.056824mm",
    height: "15.052474mm",
    viewBox: "0 0 11.056824 15.052474",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113.90309,-66.046828)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 121.80709,80.606323 V 66.559874 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 114.39986,80.526332 7.3358,-13.985716 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 124.46694,72.838529 h -9.38827 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDc2TogR);
export default __webpack_public_path__ + "static/media/dc2tog-r.66c604b697ef9fe72bd7ec8f13fae02b.svg";
export { ForwardRef as ReactComponent };